import { IconButton, Table, TableCell, TableHeading } from '@nike/eds';
import { FC } from 'react';
import ts from '../../passes/vip/i18n';
import { ts as vendorTS } from '../../passes/vendor/i18n';
import { useI18nContext } from 'context/language/use-i18n-context';
import { VIP, VendorInfo } from '../type';
import { AppConfig } from 'utils/constants';
import styles from './vendor-vip-list.module.css';

const headers = [
  { Header: 'GRID_HEADER_NAME' },
  { Header: 'GRID_HEADER_EMAIL' },
  { Header: 'GRID_HEADER_ACTIONS' },
];

type TsKeys = keyof typeof ts;

type Props = {
  VIPVendorList: VIP[] | VendorInfo[] | undefined;
  handleDelete: (vip: VIP | VendorInfo) => void;
  handleEdit: (vip: VIP | VendorInfo) => void;
  showEmail?: boolean;
  passType: number;
};

export const VIPVendorList: FC<Props> = ({ VIPVendorList, handleDelete, handleEdit, passType,showEmail=false}) => {
  const { i18nString } = useI18nContext();

  return (
    <Table>
      <thead>
        <tr>
          {headers.map(column => {
            if(column.Header === 'GRID_HEADER_EMAIL' && !showEmail) {
              return null;
            }
            else{
            return (  
            <TableHeading
              className={styles.table_header}
              data-testid={column.Header}
              key={column.Header}
            >
              {i18nString(ts[column.Header as TsKeys])}
            </TableHeading>)}
          })}
        </tr>
      </thead>
      <tbody>
        {VIPVendorList && VIPVendorList?.length > 0 ? (
          VIPVendorList?.map(vip => (
            <tr key={`${vip.email} ${vip.firstName}`}>
              <TableCell
                className={styles.table_td}
              >{`${vip.firstName} ${vip.lastName}`}</TableCell>
              {showEmail && <TableCell className={styles.table_td}>{vip.email}</TableCell>}
              <TableCell>
                <IconButton
                  label="edit"
                  data-testid="vip-list-edit"
                  size="small"
                  variant="ghost"
                  onClick={() => handleEdit(vip)}
                  icon="Edit"
                />
                <IconButton
                  label="close"
                  size="small"
                  data-testid="vip-list-close"
                  variant="ghost"
                  onClick={() => handleDelete(vip)}
                  icon="Close"
                />
              </TableCell>
            </tr>
          ))
        ) : (
          <tr>
            <TableCell data-testid="vip_list_empty">
              {passType === AppConfig.passType.vip
                ? i18nString(ts.GRID_EMPTY_TEXT_VIP)
                : i18nString(vendorTS.GRID_EMPTY_TEXT_VENDOR)}
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
